import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Badge } from '@/components/ui/badge';
import { ArrowRight, ArrowLeftRight } from 'lucide-react';
import { formatCurrency, formatDate } from '@/lib/utils';

export default function TransferInViewDialog({ item, onOpenChange }) {
    if (!item) return null;
    const t = item._transfer;
    const dest = item._dest;
    const items = dest?.items || [];
    const total = items.reduce((s, it) => s + (it.quantity || 0) * (it.price_per_unit || 0), 0);
    return (
        <Dialog open={!!item} onOpenChange={(v) => !v && onOpenChange(null)}>
            <DialogContent className="sm:!max-w-[760px] max-h-[85vh] overflow-auto">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2">
                        <ArrowLeftRight className="w-5 h-5 text-violet-600" />
                        Transfert reçu — <span className="font-mono">{t?.transfer_number}</span>
                    </DialogTitle>
                </DialogHeader>
                <div className="flex flex-wrap items-center gap-3 text-sm">
                    <span className="text-slate-500">{formatDate(item._date)}</span>
                    <span className="flex items-center gap-1.5 font-medium">
                        {t?.from_site_name}
                        <ArrowRight className="w-4 h-4 text-slate-400" />
                        {dest?.site_name}
                    </span>
                    <Badge className="bg-violet-100 text-violet-700 hover:bg-violet-100">Validé</Badge>
                </div>
                <table className="w-full text-xs border rounded-lg overflow-hidden">
                    <thead className="bg-slate-50 text-slate-500">
                        <tr>
                            <th className="text-left px-2 py-1.5">Produit</th>
                            <th className="text-left px-2 py-1.5">Fournisseur</th>
                            <th className="text-right px-2 py-1.5">Qté</th>
                            <th className="text-left px-2 py-1.5">Unité</th>
                            <th className="text-right px-2 py-1.5">P.U.</th>
                            <th className="text-right px-2 py-1.5">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((it, i) => (
                            <tr key={i} className="border-t" data-testid={`transfer-in-item-${i}`}>
                                <td className="px-2 py-1.5 font-medium">{it.product_name}</td>
                                <td className="px-2 py-1.5 text-slate-500">{it.supplier_name || '—'}</td>
                                <td className="px-2 py-1.5 text-right tabular-nums">{it.quantity}</td>
                                <td className="px-2 py-1.5">{it.unit}</td>
                                <td className="px-2 py-1.5 text-right tabular-nums">{it.price_per_unit ? formatCurrency(it.price_per_unit) : '—'}</td>
                                <td className="px-2 py-1.5 text-right tabular-nums font-semibold">{formatCurrency((it.quantity || 0) * (it.price_per_unit || 0))}</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr className="border-t bg-slate-50 font-semibold">
                            <td colSpan={5} className="px-2 py-1.5 text-right">Total</td>
                            <td className="px-2 py-1.5 text-right tabular-nums" data-testid="transfer-in-total">{formatCurrency(total)}</td>
                        </tr>
                    </tfoot>
                </table>
                {t?.notes && <p className="text-xs text-slate-500">Notes : {t.notes}</p>}
            </DialogContent>
        </Dialog>
    );
}
